import { render, staticRenderFns } from "./CollectionShowScreen.vue?vue&type=template&id=1349fb0e&"
import script from "./CollectionShowScreen.vue?vue&type=script&lang=js&"
export * from "./CollectionShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports